import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { DELIVERY_PERIOD_DESCRIPTION, TABS } from '../../../constants';

// 문안은 사업 담당자 확정 대기 중. 서버 값이 아니라 이 배열만 고치면 된다
const EXCHANGE_NOTICE_LIST = ['교환·반품은 「소비자기본법」 및 공정거래위원회 소비자분쟁해결기준에 따릅니다.', '자세한 사항은 답례품 제공자에게 문의해 주세요.'];
interface GiftTabContentDeliveryProps {
  deliveryCompanyName?: string;
  providerName?: string;
  providerBusinessNumber?: string;
  providerContactNumber?: string;
  providerAddress?: string;
}
export const GiftTabContentDelivery = t0 => {
  const $ = _c(30);
  const {
    deliveryCompanyName,
    providerName,
    providerBusinessNumber,
    providerContactNumber,
    providerAddress
  } = t0;
  let t1;
  if ($[0] !== providerName) {
    t1 = {
      key: "\uC0C1\uD638",
      value: providerName
    };
    $[0] = providerName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== providerContactNumber) {
    t2 = {
      key: "\uB300\uD45C\uBC88\uD638",
      value: providerContactNumber
    };
    $[2] = providerContactNumber;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== providerBusinessNumber) {
    t3 = {
      key: "\uC0AC\uC5C5\uC790 \uB4F1\uB85D\uBC88\uD638",
      value: providerBusinessNumber
    };
    $[4] = providerBusinessNumber;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== providerAddress) {
    t4 = {
      key: "\uC0AC\uC5C5\uC7A5 \uC18C\uC7AC\uC9C0",
      value: providerAddress
    };
    $[6] = providerAddress;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = [t1, t2, t3, t4].filter(_temp);
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const providerRowList = t5;
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("flex flex-col gap-48 px-0 pt-32", "mobile-tablet:gap-32 mobile-tablet:px-20 mobile-tablet:pt-16");
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== providerRowList) {
    t7 = providerRowList.length > 0 ? <article className="flex flex-col"><h2 className={cn("pb-16 font-600 text-Gray-900 typo-h5", "mobile-tablet:pb-8 mobile-tablet:typo-body1")}>답례품 제공자 정보</h2><ul className={cn("flex flex-col border-t border-Gray-200 font-400 text-Gray-600 typo-body3 [&>li>p]:w-140 [&>li>span]:flex-1 [&>li>span]:font-500 [&>li>span]:text-Gray-700 [&>li]:border-b [&>li]:border-Gray-200 [&>li]:py-14", "mobile-tablet:typo-body4 mobile-tablet:[&>li>p]:w-92 mobile-tablet:[&>li]:py-10")}>{providerRowList.map(_temp2)}</ul></article> : null;
    $[14] = providerRowList;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t10;
  let t8;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h2 className={cn("pb-16 font-600 text-Gray-900 typo-h5", "mobile-tablet:pb-8 mobile-tablet:typo-body1")}>구매/배송</h2>;
    t9 = <p className={cn("mb-24 font-400 text-Gray-600 typo-body3", "mobile-tablet:mb-16 mobile-tablet:typo-body4")}>물류 상황에 따라 배송이 지연될 수 있음을 양해 부탁드립니다.</p>;
    t10 = cn("flex flex-col border-t border-Gray-200 font-400 text-Gray-600 typo-body3 [&>li>p]:w-140 [&>li>span]:flex-1 [&>li>span]:font-500 [&>li>span]:text-Gray-700 [&>li]:border-b [&>li]:border-Gray-200 [&>li]:py-14", "mobile-tablet:typo-body4 mobile-tablet:[&>li>p]:w-92 mobile-tablet:[&>li]:py-10");
    $[16] = t10;
    $[17] = t8;
    $[18] = t9;
  } else {
    t10 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t11;
  if ($[19] !== deliveryCompanyName) {
    t11 = deliveryCompanyName ? <li className="flex items-center gap-16"><p>배송방법</p><span>{deliveryCompanyName}</span></li> : null;
    $[19] = deliveryCompanyName;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <li className="flex items-center gap-16"><p>배송 지역</p><span>전국</span></li>;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <li className="flex items-center gap-16"><p>배송비</p><span>무료</span></li>;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <li className="flex items-center gap-16"><p>배송 기간</p><span>{DELIVERY_PERIOD_DESCRIPTION}</span></li>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t11) {
    t15 = <article className="flex flex-col">{t8}{t9}<ul className={t10}>{t11}{t12}{t13}{t14}</ul></article>;
    $[24] = t11;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <article className="flex flex-col"><h2 className={cn("pb-16 font-600 text-Gray-900 typo-h5", "mobile-tablet:pb-8 mobile-tablet:typo-body1")}>교환/반품/취소 유의사항</h2><ul className={cn("flex flex-col gap-8 font-400 text-Gray-600 typo-body3", "mobile-tablet:gap-8 mobile-tablet:typo-body4")}>{EXCHANGE_NOTICE_LIST.map(_temp3)}</ul></article>;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t15 || $[28] !== t7) {
    t17 = <section className={t6} id={TABS.DELIVERY}>{t7}{t15}{t16}</section>;
    $[27] = t15;
    $[28] = t7;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
};
function _temp(row) {
  return Boolean(row.value);
}
function _temp2(row_0) {
  return <li key={row_0.key} className="flex items-center gap-16"><p>{row_0.key}</p><span>{row_0.value}</span></li>;
}
function _temp3(notice) {
  return <li key={notice} className="flex gap-8"><span aria-hidden={true}>·</span><span className="flex-1">{notice}</span></li>;
}